<template>
  <div class="home">
    <section class="section">
      <div class="container-fluid">
        <h1 class="title has-text-centered">
          Welcome to Kingston Smith Association Management Utilities
        </h1>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-12-mobile is-3-desktop">
            <div class="card">
              <div class="card-image">
                <figure class="image is-4by3">
                  <a href="/gl-export">
                    <img
                      src="@/assets/images/gl-export-img.png"
                      alt="Placeholder image"
                    />
                  </a>
                </figure>
              </div>
              <div class="card-content">
                <div class="content">
                  <p class="title is-4">
                    <a href="/gl-export">
                      GL Export Utility
                    </a>
                  </p>
                  <p>A tool to format and export GL Data in a Sage Format</p>
                </div>
                <b-button
                  type="is-primary"
                  tag="router-link"
                  class="is-fullwidth"
                  :to="{ path: '/gl-export' }"
                >
                  Visit
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {},
  data() {
    return {};
  },
};
</script>
